import { Fragment } from "react";
import BasicButton from "../../common/components/BasicButton";
import BoxWithShadow from "../../common/components/BoxWithShadow";
import CountCard from "../../common/components/CountCard";
import { useGetBannerCountsAsAdminQuery } from "../../../lib/apollo/graphql/generated";
import Loader from "../../common/components/Loader";

interface MetadataBoxProps {
  onCreateBanner: () => void;
}

export default function MetadataBox({ onCreateBanner }: MetadataBoxProps) {
  const { data, loading } = useGetBannerCountsAsAdminQuery();
  const counts = data?.getBannersCountAsAdmin;

  return (
    <Fragment>
      <BoxWithShadow className="w-1/6 flex-shrink-0">
        <p className="text-lg font-bold">배너 현황</p>
        {loading ? (
          <Loader />
        ) : (
          <div className="flex flex-col gap-3">
            <CountCard label="전체 배너" unit="개" count={counts?.totalCount} />
            <CountCard
              label="활성 배너"
              unit="개"
              count={counts?.activeCount}
            />
            <CountCard
              label="예약 배너"
              unit="개"
              count={counts?.reservedCount}
            />
            <CountCard
              label="비활성 배너"
              unit="개"
              count={counts?.inactiveCount}
            />
          </div>
        )}
        <BasicButton
          text="배너 추가"
          className="mt-auto w-full"
          onClick={onCreateBanner}
        />
      </BoxWithShadow>
    </Fragment>
  );
}
